import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useRecordContext, useNotify } from 'react-admin'

const getMotorTradingData = async (leadID) => {
  const entrypoint = process.env.REACT_APP_API_PLATFORM_ENDPOINT

  const params = new URLSearchParams({ quoteID: leadID })
  const response = await fetch(
    `${entrypoint}/services/quote/motor-trading?${params}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  )

  const json = await response.json()

  if (json.Error) throw new Error('Error fetching Motor Trading data')

  return json
}

const MTButton = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(false)

  const handleOpen = async () => {
    if (!record?.id) return

    setOpen(true)
    setLoading(true)

    try {
      const data = await getMotorTradingData(record.id)

      if (data.result === 'error') {
        setContent(data.message || 'No message provided')
      } else if (data.payload) {
        setContent(data.payload)
      } else {
        setContent('No content returned.')
      }
    } catch (error) {
      console.error(error)
      notify(error.message || 'Failed to fetch Motor Trading data', {
        type: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => setOpen(false)

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="sm">
        <DialogTitle>Motor Trading</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Button fullWidth onClick={handleOpen} color="primary" disabled={loading}>
        MT
      </Button>
    </>
  )
}

export default MTButton
